var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");
var lib_geometry = require("lib-geometry");

var HoleData = cio_datamodel.HoleData;

var DrillToolStateMachine = function (root, editorModel, selectionModel, dataCollection, options){
    this.root = root;
    this.dataCollection = dataCollection;
    this.options = options;

    editor_2d.PlacingStateMachine.call(this, root, editorModel, selectionModel, this.options.multiplePlacing);
};

lib_core.inherit(DrillToolStateMachine, editor_2d.PlacingStateMachine);

module.exports = DrillToolStateMachine;

DrillToolStateMachine.prototype.createElement = function (startCoord) {
    var shape = new cio_datamodel.EllipseData(new lib_geometry.Coord(0,0), 0, this.options.diameter, this.options.diameter, true, 0);
    var drill = new HoleData(startCoord, 0, shape);

    drill.addTo(this.dataCollection);

    return this.editorModel.interactionModelDataMap.get(drill);
};

